module.exports = __webpack_public_path__ + "static/media/loading.d2c129db.svg";